import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription, of } from 'rxjs';
import { OpeService } from 'src/app/services/ope/ope.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { Ope } from 'src/app/models/Ope';
import { HttpErrorResponse } from '@angular/common/http';
import { SidebarService } from 'src/app/services/sideBare.service';
import { EnumTypeNotification } from 'src/app/enumeration/EnumTypeNotification';
import { KeycloakService } from 'keycloak-angular';
import { GlobalSearchComponent } from 'src/app/global-composants/global-search/global-search.component';
import { MapSearchComponent } from 'src/app/global-composants/map-search/map-search.component';
import { ErrorbadrequestComponent } from 'src/app/global-composants/error/errorbadrequest/errorbadrequest.componet';
import { ListeCardsComponent } from 'src/app/tableaux-listes/liste-cards/liste-cards.component';


@Component({
  selector: 'app-page-accueil',
  templateUrl: './page-accueil.component.html',
  imports : [GlobalSearchComponent,MapSearchComponent,ErrorbadrequestComponent,ListeCardsComponent],
  styleUrls: ['./page-accueil.component.scss']
})
export class PageAccueilComponent implements OnInit, OnDestroy {

  listope: Ope[] = [];
  criterisa!: SearchOpeCriteria | null;
  loader = true;
  montag!: HTMLElement;
  showError: boolean = false;
  error: string = "MES MSG";
  showErrorTechnique: boolean = false;
  spinner: any;
  container: boolean = false;
  showprogressbar: boolean = false;
  private _destroy$!: Subject<boolean>;
  private destroy$!: Subject<boolean>;
  ServiceSubscriptions: Subscription = new Subscription();

  constructor(private readonly _sidebar: SidebarService, public share: shareOpeSevices, private readonly opeservice: OpeService, private readonly keycloakService: KeycloakService) {
    this.criterisa = new SearchOpeCriteria();
    this.criterisa = null;

  }


  ngOnInit(): void {


    const userRoles = this.keycloakService.getUserRoles();


    //this.destroy$ = new Subject<boolean>();
    //this._destroy$ = new Subject<boolean>();
    //this.listope = [];
    if (this.share.intSearchcrit) {
      this.ServiceSubscriptions = this.share.searchcrit$.subscribe(
        data => {
          if (data != null) {
            this.criterisa = data
            this.getopebycriteria(this.criterisa, userRoles[0]);
          }
        }
      );
      this.share.intSearchcrit = false;
    }


    /* if (this.share.initSearchcrit) {
       this.share.initSearchcrit = false;
    }
    else {
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;

      }
    }*/


    /*this.share.userProfilshared$.subscribe({
      next:(datao:userProfilDto)=>{
        this.ServiceSubscriptions=new Subscription();
        this.destroy$ = new Subject<boolean>();
        this._destroy$= new Subject<boolean>();
        this.listope = [];
        this.ServiceSubscriptions= this.share.searchcrit$.pipe(
          takeUntil(this._destroy$)
          ).subscribe(
            
            data => {
            
              this.criterisa = data
              if(this.criterisa==null){
                this.criterisa = new SearchOpeCriteria();
                this.criterisa.nbmoisLivraison=[0,36]
              }
              
              this.getopebycriteria(this.criterisa,datao?.role[0]);
             
            }
          );
      },
      complete:()=>{
       
       
      }
  
    });*/
    /*
    this.share.userProfilshared$.subscribe(datao=>{
    this.ServiceSubscriptions=new Subscription();
    this.destroy$ = new Subject<boolean>();
    this._destroy$= new Subject<boolean>();
    this.listope = [];
    this.ServiceSubscriptions= this.share.searchcrit$.pipe(
      takeUntil(this._destroy$)
      ).subscribe(data => {
        
          this.criterisa = data
          if(this.criterisa==null){
            this.criterisa = new SearchOpeCriteria();
            this.criterisa.nbmoisLivraison=[0,36]
          }
          this.getopebycriteria(this.criterisa);
        });
  });*/

  }


  getopebycriteria(filtrer: SearchOpeCriteria, role: string) {


    this.opeservice.getOpebyCriteria(filtrer, role)
      //.pipe(debounceTime(50),
      //  distinctUntilChanged(), catchError(this.handleError),takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.container = true;
          this.showError = true;
          this.loader = true;
          this.showErrorTechnique = false;
          this.share.affichenotfound = false;
          this.share.callApi = false;


          if (data.content.length > 0) {

            this.listope.length = 0;
            //this.share.sendOpes(this.listope);
            this.listope = data.content;
            //this.share.sendOpes(this.listope);
            this.showErrorTechnique = false;
            if (window.location.pathname == '/accueil') {
              this._sidebar.addNewNotification(
                EnumTypeNotification.INFO,
                'Bonne nouvelle ! ' + data.content.length + ' élément(s) trouvé(s)', '',
                true,
                true
              );
            }
            this.container = false;
            if (this.share.showprogressbar == true) {
              this.share.showprogressbar = false;
            };
            /*const sasa = document.getElementById("montag")
            sasa?.scrollIntoView({ behavior: 'smooth' })*/
          }
          else if (data.content.length === 0) {
            this.showErrorTechnique = false;
            this.share.affichenotfound = true
            if (window.location.pathname == '/accueil') {
              this._sidebar.addNewNotification(
                EnumTypeNotification.ERREUR,
                '' + data.content.length + ' élément(s) trouvé(s)',
                '',
                true,
                true
              );
            }
            this.listope = [];
            //this.share.sendOpes(this.listope);

            this.share.sendboolean(true);
            if (this.share.showprogressbar == true) {
              this.share.showprogressbar = false;
            };
            /*const sasa = document.getElementById("montag")
            sasa?.scrollIntoView({ behavior: 'smooth' })*/
          }

        }, complete: () => {
          this.share.sendOpes(this.listope);
        }

      })
  }
  handleError = (error: HttpErrorResponse) => {
    this.listope.length = 0;
    //this.share.sendOpes(this.listope);
    if (error.status === 404 || error.status === 400) {

      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Communication interrompu avec Open : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );

      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;

      }
      this.showErrorTechnique = true;
      //return of(error.message);

    } if (error.status === 503) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');
      this.listope.length = 0;
      //this.share.sendOpes(this.listope);
      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Service indsponible - code erreur : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      this.showErrorTechnique = true;
      //return of(error.message);
    }
    //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');

    if (error.status === 502) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');
      this.listope.length = 0;
      //this.share.sendOpes(this.listope);
      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Bad Gatway - POD ne repond pas - code erreur : ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      this.showErrorTechnique = true;
      //return of(error.message);
    }
    if (error.status === 504) {
      //window.alert( 'Erreur technique - code erreur : '+error.status+' - veuillez contacter un adminstateur');
      this.listope.length = 0;
      //this.share.sendOpes(this.listope);
      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Timeout Gatway - code erreur ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      this.showErrorTechnique = true;
      //return of(error.message);
    }


    if (error.status === 500) {
      this.listope.length = 0;
      //this.share.sendOpes(this.listope);
      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Mauvaise requette, veuillez bien selectionner les bons param - code erreur ' + error.status + ' .',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      this.showErrorTechnique = true;
      //return of(error.message);
    }
    else {
      this.listope.length = 0;
      //this.share.sendOpes(this.listope);
      this.error = error.message;
      this._sidebar.addNewNotification(
        EnumTypeNotification.ERREUR,
        'Erreur Inconnu  - code erreur ' + error.status + ' - veuillez contacter un adminstateur',
        '',
        true,
        true
      );
      if (this.share.showprogressbar == true) {
        this.share.showprogressbar = false;
      }
      this.showErrorTechnique = true;
      //return of(error.message);
    }
    this.share.sendOpes(this.listope);
    return of(error.message);

  };



  ngOnDestroy() {
    /*this.destroy$.next(true);
    this.destroy$.complete();
    this._destroy$.next(true);
    this._destroy$.complete();
    this.ServiceSubscriptions.unsubscribe();*/

  }
}
